<template>
  <v-container class="pt-0" style="height: 100%">
    <v-row>
      <v-col class="mx-0 px-0 pt-0">
        <header-text-bg :site="site" text="profile" />
      </v-col>
    </v-row>

    <v-container fluid class="pa-0">
      <v-card-text class="text-center card-img card-profile-container">
        <input
          type="file"
          ref="fileInput"
          accept="image/*"
          style="display: none"
          @change="onFileUpload"
        />

        <div>
          <v-badge
            @click.native="triggerFileInput()"
            style="cursor: pointer"
            bordered
            overlap
            :value="is_can_edit_image_profile"
            icon="mdi-camera"
            :color="site.color || 'primary'"
            offset-x="24"
            offset-y="30"
            class="profile-avatar-badge"
          >
            <v-avatar
              size="100"
              class="elevation-3"
              style="border: 4px solid white"
            >
              <v-img
                :lazy-src="dataItems.profile_path"
                :src="
                  url
                    ? url
                    : dataItems.profile_path
                    ? dataItems.profile_path
                    : defaultImage
                "
                style="background-color: #eeeeee"
              ></v-img>
            </v-avatar>
          </v-badge>
        </div>

        <v-btn
          v-if="!isEditing && is_can_edit_profile"
          :color="site.color || 'primary'"
          rounded
          depressed
          class="mt-4 px-8 text-capitalize"
          @click="editProfile"
        >
          <v-icon left small color="white"> mdi-pencil </v-icon>
          <span class="white--text">{{ $t("editProfile") }}</span>
        </v-btn>
      </v-card-text>

      <v-row justify="center" class="mt-n6">
        <v-col cols="12" sm="8" style="padding-top: 0px !important">
          <v-card v-if="!isEditing" outlined class="mx-4 my-6">
            <div
              v-for="(field, index) in profileFields"
              :key="`field-${index}`"
            >
              <v-divider v-if="index > 0" class="mx-4"></v-divider>

              <v-list-item class="menu-item">
                <v-list-item-icon class="mr-4">
                  <v-icon :color="site.color">{{ getFieldIcon(field) }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle class="text-caption">
                    {{ formatMyQuestion(field.name) }}
                  </v-list-item-subtitle>
                  <v-list-item-title class="font-weight-medium">
                    <div>
                      <!-- Image -->
                      <div
                        v-if="checkTypeMyQuestion(field.name) === 'image'"
                        class="d-flex flex-wrap"
                        style="gap: 8px"
                      >
                        <img
                          v-for="(itemImage, i) in formatMyDetail(field.name)"
                          :key="i"
                          style="
                            width: 100%;
                            max-width: fit-content;
                            max-height: 120px;
                            object-fit: contain;
                            border-radius: 4px;
                          "
                          :src="itemImage.content"
                          @click="handleClickPreviewFormQuestion(itemImage)"
                        />
                      </div>
                      <!-- Text -->
                      <div
                        v-else-if="checkTypeMyQuestion(field.name) === 'text'"
                        style="
                          font-size: 16px;
                          white-space: pre-line;
                          word-break: break-word;
                        "
                      >
                        {{ formatMyDetail(field.name) }}
                      </div>
                    </div>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </div>
          </v-card>

          <div v-if="isEditing">
            <div class="mb-2" style="text-align: right">
              <v-btn
                icon
                elevation="2"
                :color="site.color"
                style="background-color: #ffffff"
                @click="cancelEdit"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
            <Survey v-if="survey" :survey="survey" style="border-radius: 8px">
            </Survey>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <DialogVerifyOtp
      ref="refVerifyOTP"
      v-model="dialogOtp"
      :dialogOtp="dialogOtp"
      :ref_code="ref_code"
      :site="site"
      @close="dialogOtp = false"
      @verifyOtp="verifyOtp"
      @sendOtp="sendOtp"
    ></DialogVerifyOtp>

    <DialogPreviewFile
      :dialogOpen="filePreview.dialog"
      :fileUrl="filePreview.url"
      :fileName="filePreview.name"
      @onClose="handleClosePreview"
    />
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import Axios from "@/config/customer-service.js";
import headerTextBg from "../../../components/headerTextBg.vue";
import DialogVerifyOtp from "@/components/dialogVerifyOtp.vue";
import { Survey } from "survey-vue-ui";
import { Model } from "survey-vue";
import "survey-core/defaultV2.min.css";
import { themeJson } from "../../../scss/themeJson.js";
import { provinces } from "../../../config/location/provinces.js";
import { districts } from "../../../config/location/districts.js";
import { sub_districts } from "../../../config/location/sub_districts.js";
import {
  addClassQlEditorToSDDisplay,
  addDivCustomInputMaskPattern,
  checkTypeQuestion,
  formatDetail,
  formatQuestion,
  formattedForSave,
  transformJsonCustomInputMask,
} from "../../../config/general-function.js";
import DialogPreviewFile from "../../../components/dialog-preview-file.vue";

const customCss = {
  question: {
    content: "question-content",
    titleRequired: "question-title-required",
  },
};

export default {
  components: { headerTextBg, DialogVerifyOtp, Survey, DialogPreviewFile },
  inject: ["isAppLoading"],
  name: "edit-profile",
  data() {
    return {
      dataItems: {},
      url: null,
      defaultImage: require("@/assets/images/user.svg"),
      isEditing: false,
      is_can_edit_profile: false,
      is_can_edit_image_profile: false,
      survey: null,
      editForm: {},
      profileFields: [],
      dialogOtp: false,
      ref_code: "",
      request_id: "",
      pendingSurveyData: null,

      filePreview: {
        dialog: false,
        url: "",
        name: "",
        description: "",
      },
    };
  },
  computed: {
    ...mapState("defaultSystem", ["site"]),
  },
  created() {
    this.initialize();
  },
  methods: {
    // ========== ========== Form ========== ==========
    getFieldIcon(field) {
      if (!field || !field.name) {
        return "mdi-information-outline";
      }

      const name = field.name.toLowerCase();

      if (name.includes("question1")) {
        return "mdi-account-outline";
      }
      if (name.includes("question2")) {
        return "mdi-account-outline";
      }
      if (name.includes("email")) {
        return "mdi-email-outline";
      }
      if (name.includes("question3")) {
        return "mdi-phone-outline";
      }
      if (name.includes("birth_date")) {
        return "mdi-cake-variant";
      }
      if (name.includes("gender")) {
        return "mdi-gender-male-female";
      }

      return "mdi-information-outline";
    },
    formatMyQuestion(question) {
      const label = formatQuestion(question, this.dataItems.register_schema);
      return label;
    },
    formatMyDetail(question) {
      const value = formatDetail(
        this.dataItems.detail[question],
        question,
        this.dataItems.register_schema
      );
      return value;
    },
    checkTypeMyQuestion(question) {
      return checkTypeQuestion(question, this.dataItems.register_schema);
    },
    handleClickPreviewFormQuestion(param) {
      this.filePreview.url = param.content;
      this.filePreview.name = param.name;
      this.filePreview.dialog = true;
    },
    // ========== ========== ========== ==========
    handleClosePreview() {
      this.filePreview.dialog = false;
    },
    async handleClickDownload(event, param) {
      event.stopPropagation();
      this.isAppLoading(true);
      try {
        let filename = param.name;
        let response = await fetch(param.url, {
          cache: "no-cache",
        });
        let blob = await response.blob();
        let url = await URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.crossOrigin = "Anonymous";
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } catch (err) {
        this.$swal.fire({
          icon: "error",
          title: JSON.stringify(err?.response?.data),
          showConfirmButton: false,
          timer: 3000,
        });
      }
      this.isAppLoading(false);
    },
    // ========== ========== ========== ==========

    createSurvey() {
      if (!this.editForm.completeText) {
        this.editForm.completeText = this.$t("submit");
      }
      this.editForm.showCompletedPage = false;
      this.editForm.checkErrorsMode = "onValueChanged";
      this.editForm = this.setQuestionAddress(this.editForm);
      this.editForm = transformJsonCustomInputMask(this.editForm);
      this.survey = new Model(this.editForm);

      if (this.survey) {
        if (this.dataItems.detail) {
          this.survey.data = { ...this.dataItems.detail };
          this.setSurveyValue();
        }

        this.survey.onComplete.add(async (sender) => {
          sender.doComplete = function () {};

          await this.handleSurveyComplete(sender, {
            showSaveInProgress: () => {},
            showSaveSuccess: () => this.survey.doComplete(),
            showSaveError: () => {},
          });
        });

        let _themeJson = { ...themeJson };
        if (this.dataItems?.theme) {
          _themeJson = { ...this.dataItems.theme };
          if (!_themeJson.backgroundImage) {
            _themeJson.backgroundImage = "";
          }
        } else {
          this.survey.css = customCss;
          _themeJson.cssVariables["--sjs-primary-backcolor"] = this.site.color;
          _themeJson.cssVariables["--sjs-primary-backcolor-dark"] =
            this.site.color;
        }

        this.survey.applyTheme(_themeJson);
        this.onValueChanged();
        this.onAfterRenderPage();
        this.onAfterRenderQuestion();
      }
    },
    async handleSurveyComplete(sender, options) {
      options.showSaveInProgress();

      try {
        const surveyData = sender.data;
        const phoneValue = surveyData.question3;

        if (!phoneValue) {
          this.$swal.fire(
            this.$t("error.title"),
            this.$t("invalidPhoneNumber"),
            "error"
          );
          options.showSaveError();
          return;
        }

        // Step 1: checkDuplicateKeyLoginEditProfile
        const checkDuplicateBody = {
          key_login: "phone",
          value_login: phoneValue,
        };
        this.isAppLoading(true);
        const duplicateRes = await Axios.post(
          `checkDuplicateKeyLoginEditProfile`,
          checkDuplicateBody
        );

        if (duplicateRes.data.status !== "success") {
          await this.$swal.fire(
            this.$t("duplicateData"),
            duplicateRes.data.error || this.$t("errPhoneIsUsed"),
            "error"
          );
          options.showSaveError();
          this.isAppLoading(false);
          this.isEditing = false;
          return;
        }

        // Step 2: เช็ค is_login_bypass
        if (this.dataItems.is_login_bypass === false) {
          const responseProcessedData = await this.processImageData(surveyData);
          if (responseProcessedData.has_heic) {
            options.showSaveError();
            sender.clear(false);
            if (responseProcessedData.question_name_has_heic) {
              const targetQuestion = sender.getQuestionByName(
                responseProcessedData.question_name_has_heic
              );
              if (targetQuestion) {
                targetQuestion.addError(this.$t("error.heicNotSupported"));
                targetQuestion.focus();
              }
            }
            this.isAppLoading(false);
            return;
          }
          this.pendingSurveyData = responseProcessedData.processedData;

          // Step 3: ส่ง OTP
          await this.sendOtp(phoneValue);

          options.showSaveSuccess();
        } else {
          // ไม่ต้องยืนยัน OTP สามารถบันทึกได้เลย
          const responseProcessedData = await this.processImageData(surveyData);
          if (responseProcessedData.has_heic) {
            options.showSaveError();
            sender.clear(false);
            if (responseProcessedData.question_name_has_heic) {
              const targetQuestion = sender.getQuestionByName(
                responseProcessedData.question_name_has_heic
              );
              if (targetQuestion) {
                targetQuestion.addError(this.$t("error.heicNotSupported"));
                targetQuestion.focus();
              }
            }
            this.isAppLoading(false);
            return;
          }
          await this.submitEditProfile(responseProcessedData.processedData);
          options.showSaveSuccess();
        }
      } catch (error) {
        console.error("Error in handleSurveyComplete:", error);
        this.$swal.fire({
          icon: "error",
          text: error.response?.data?.message || this.$t("errSubmissionFailed"),
          showConfirmButton: false,
          timer: 2000,
        });
        options.showSaveError();
      }
    },
    async processImageData(surveyData) {
      let returnData = {
        has_heic: false,
        question_name_has_heic: null,
        processedData: { ...surveyData },
      };

      if (typeof returnData.processedData === "object") {
        for (let key of Object.keys(returnData.processedData)) {
          let question = returnData.processedData[key];
          if (Array.isArray(question) && question.length > 0) {
            if (
              this.isImage(question[0].name) ||
              this.isVideo(question[0].name) ||
              this.isPDF(question[0].name) ||
              this.isSpreadsheet(question[0].name)
            ) {
              const imageFile = await this.convertBase64ToFile(
                question[0].content,
                question[0].name
              );
              const imageUrl = await this.uploadImageDefault(imageFile);
              question[0].content = imageUrl;
            } else if (this.isHeic(question[0].name)) {
              returnData.has_heic = true;
              question = null;
              returnData.question_name_has_heic = key;
            }
          }
        }
      }

      return returnData;
    },
    async sendOtp(mobile) {
      try {
        this.isAppLoading(true);

        const res = await Axios.post("sendOtpNormal", {
          mobile: mobile,
        });

        if (res.data.status === "success") {
          this.request_id = res.data.data.request_id;
          this.ref_code = res.data.data.ref_code;
          this.dialogOtp = true;

          this.$swal.fire({
            icon: "success",
            title: res.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
        } else {
          throw new Error(res.data.message);
        }
      } catch (error) {
        console.error("Error sending OTP:", error);
        this.$swal.fire({
          icon: "error",
          text: error.response?.data?.message,
          showConfirmButton: true,
        });
        throw error;
      } finally {
        this.isAppLoading(false);
      }
    },
    verifyOtp(code) {
      this.isAppLoading(true);
      Axios.post("checkOtp", {
        request_id: this.request_id,
        code: code,
      })
        .then((res) => {
          if (res.data.status === "success") {
            this.$swal
              .fire({
                icon: "success",
                title: this.$t("successOTPVerified"),
                showConfirmButton: false,
                timer: 1500,
              })
              .then(() => {
                this.dialogOtp = false;
                // Step 4: Success แล้วค่อย submitEditProfile
                this.submitEditProfile(this.pendingSurveyData);
              });
          } else {
            this.isAppLoading(false);
          }
        })
        .catch((err) => {
          this.isAppLoading(false);
          if (this.$refs.refVerifyOTP) {
            this.$refs.refVerifyOTP.clearOTP();
          }
          if (err.response.status === 400 || err.response.status === 500) {
            this.$swal.fire({
              icon: "error",
              text: err?.response?.data?.message || err.message,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        });
    },
    setSurveyValue() {
      const detail = this.dataItems?.detail || null;
      const elements = this.editForm?.elements || [];
      for (const item of elements) {
        const questionName = item.name;
        const answer = detail[questionName];
        if (detail && answer != undefined) {
          this.survey.setValue(questionName, detail[questionName]);
        }
        // ========== ========== Address ========== ==========
        if (questionName == "district") {
          const answer_province = detail["province"];
          const district = this.survey.getQuestionByName("district");
          if (district && answer_province) {
            district.readOnly = answer_province ? false : true;
            district.choices = districts
              .filter((x) => x.province_id == answer_province)
              .map((x) => {
                return {
                  value: x.id,
                  text: x.name_th,
                };
              });
          }
        }
        if (questionName == "sub_district") {
          const answer_district = detail["district"];
          const sub_district = this.survey.getQuestionByName("sub_district");
          if (sub_district && answer_district) {
            sub_district.readOnly = answer_district ? false : true;
            sub_district.choices = sub_districts
              .filter((x) => x.district_id == answer_district)
              .map((x) => {
                return {
                  value: x.id,
                  text: x.name_th,
                };
              });
          }
        }
        if (questionName == "zip_code") {
          const answer_sub_district = detail["sub_district"];
          const zip_code = this.survey.getQuestionByName("zip_code");
          if (zip_code && answer_sub_district) {
            let choices = [];
            const model = sub_districts.find(
              (x) => x.id == answer_sub_district
            );
            for (let item of model.zip_codes) {
              choices.push({
                value: `${model.id}_${item}`,
                text: `${item}`,
              });
            }
            zip_code.choices = choices;
          }
        }
        // ========== ========== ========== ==========
      }
    },
    onValueChanged() {
      const _isAppLoading = (param) => {
        this.isAppLoading(param);
      };
      this.survey.onValueChanged.add((sender, options) => {
        const name = options.name;
        const value = options.value;
        const questions = this.survey.getAllQuestions();
        // ========== ========== Set Null Value Invisible Question ========== ==========
        const invisible_questions = questions.filter((x) => !x.visible);
        for (let invisible_question of invisible_questions) {
          const _name = invisible_question.name;
          const model = this.survey.getQuestionByName(_name);
          if (model) {
            this.survey.setValue(_name, null);
          }
        }
        // ========== ========== Address ========== ==========
        if (name == "province") {
          const district = this.survey.getQuestionByName("district");
          if (district) {
            let list = [];
            let readOnly = true;
            if (value) {
              readOnly = false;
              list = districts
                .filter((x) => x.province_id == value)
                .map((x) => {
                  return {
                    value: x.id,
                    text: x.name_th,
                  };
                });
            }
            district.readOnly = readOnly;
            district.choices = list;
            // ========== ========== ========== ==========
            _isAppLoading(true);
            const page = district.page;
            page.removeElement(district);
            setTimeout(() => {
              const _province = this.survey.getQuestionByName("province");
              const _page = _province.page;
              const originalIndex = _page.elements.indexOf(_province);
              this.survey.setValue("district", null);
              _page.addElement(district, originalIndex + 1);
              _isAppLoading(false);
            }, 100);
          }
        }
        if (name == "district") {
          const sub_district = this.survey.getQuestionByName("sub_district");
          if (sub_district) {
            let list = [];
            let readOnly = true;
            if (value) {
              readOnly = false;
              list = sub_districts
                .filter((x) => x.district_id == value)
                .map((x) => {
                  return {
                    value: x.id,
                    text: x.name_th,
                  };
                });
            }
            sub_district.readOnly = readOnly;
            sub_district.choices = list;
            // ========== ========== ========== ==========
            _isAppLoading(true);
            const page = sub_district.page;
            page.removeElement(sub_district);
            setTimeout(() => {
              const _district = this.survey.getQuestionByName("district");
              const _page = _district.page;
              const originalIndex = _page.elements.indexOf(_district);
              this.survey.setValue("sub_district", null);
              _page.addElement(sub_district, originalIndex + 1);
              _isAppLoading(false);
            }, 100);
          }
        }
        if (name == "sub_district") {
          const zip_code = this.survey.getQuestionByName("zip_code");
          if (zip_code) {
            let list = [];
            let readOnly = true;
            let _value = null;
            if (value) {
              readOnly = false;
              const model = sub_districts.find((x) => x.id == value);
              const zip_codes = model?.zip_codes || [];
              if (zip_codes.length > 0) {
                _value = `${model.id}_${zip_codes[0]}`;
              }
              for (let item of zip_codes) {
                list.push({
                  value: `${model.id}_${item}`,
                  text: `${item}`,
                });
              }
            }
            zip_code.readOnly = readOnly;
            zip_code.choices = list;
            // ========== ========== ========== ==========
            _isAppLoading(true);
            const page = zip_code.page;
            page.removeElement(zip_code);
            setTimeout(() => {
              const _sub_district =
                this.survey.getQuestionByName("sub_district");
              const _page = _sub_district.page;
              const originalIndex = _page.elements.indexOf(_sub_district);
              this.survey.setValue("zip_code", _value);
              _page.addElement(zip_code, originalIndex + 1);
              _isAppLoading(false);
            }, 100);
          }
        }
        // ========== ========== ========== ==========
      });
    },
    onAfterRenderPage() {
      this.survey.onAfterRenderPage.add(function (sender, options) {
        console.log(options);
        addClassQlEditorToSDDisplay();
      });
    },
    onAfterRenderQuestion() {
      this.survey.onAfterRenderQuestion.add((sender, options) => {
        const jsonObj = options.question.jsonObj;
        const prefix = jsonObj._customPrefix;
        const questionEl = options.htmlElement;
        if (prefix) {
          addDivCustomInputMaskPattern(questionEl, prefix);
        }
        addClassQlEditorToSDDisplay();
      });
    },
    setQuestionAddress(schema) {
      let pages = schema?.pages || [];
      const setAddress = (elements) => {
        if (Array.isArray(elements)) {
          const province = elements.find((x) => x.name == "province");
          if (province) {
            province.choices = provinces.map((x) => {
              return {
                value: x.id,
                text: x.name_th,
              };
            });
          }
          // ========== ========== ========== ==========
          const district = elements.find((x) => x.name == "district");
          if (district) {
            district.readOnly = true;
          }
          // ========== ========== ========== ==========
          const sub_district = elements.find((x) => x.name == "sub_district");
          if (sub_district) {
            sub_district.readOnly = true;
          }
          // ========== ========== ========== ==========
          const zip_code = elements.find((x) => x.name == "zip_code");
          if (zip_code) {
            zip_code.readOnly = true;
          }
        }
        return elements;
      };
      if (Array.isArray(pages) && pages.length > 0) {
        for (let item of pages) {
          let elements = item?.elements || [];
          elements = setAddress(elements);
          if (item) {
            item.elements = elements;
          }
        }
        if (schema) {
          schema.pages = pages;
        }
      } else {
        let elements = schema?.elements || [];
        elements = setAddress(elements);
        if (schema) {
          schema.elements = elements;
        }
      }
      return schema;
    },
    async submitEditProfile(surveyData) {
      this.isAppLoading(true);
      // ========== ========== ========== ==========
      const formatJson = formattedForSave(this.survey.jsonObj, surveyData);
      // ========== ========== ========== ==========
      const updateData = { detail: formatJson };
      Axios.post(`submitEditProfile`, updateData)
        .then((res) => {
          if (res.data.status === "success") {
            this.$swal.fire({
              icon: "success",
              title: this.$t("saveSuccess"),
              showConfirmButton: false,
              timer: 2000,
            });
            this.isEditing = false;
            this.pendingSurveyData = null;
            this.initialize();
          } else {
            this.$swal.fire(this.$t("error.title"), res.data.error, "error");
          }
        })
        .catch(() => {
          this.$swal.fire({
            icon: "error",
            text: this.$t("errSubmissionFailed"),
            showConfirmButton: false,
            timer: 2000,
          });
        })
        .finally(() => {
          this.isAppLoading(false);
        });
    },
    editProfile() {
      if (!this.isEditing) {
        this.createSurvey();
        this.isEditing = true;
      }
    },
    initialize() {
      this.isAppLoading(true);

      Axios.get("getEditProfile")
        .then(({ data }) => {
          const fetchData = data.data;
          this.dataItems = fetchData;
          this.is_can_edit_profile = fetchData.is_can_edit_profile;
          this.is_can_edit_image_profile = fetchData.is_can_edit_image_profile;

          if (fetchData.register_schema && fetchData.register_schema.elements) {
            this.profileFields = fetchData.register_schema.elements.map(
              (element) => ({
                name: element.name,
                title: element.title,
                type: element.type,
              })
            );
          }
          if (fetchData.schema) {
            this.editForm = { ...fetchData.schema };
          }
          if (
            !this.editForm?.elements ||
            !Array.isArray(this.editForm?.elements) ||
            (Array.isArray(this.editForm?.elements) &&
              this.editForm?.elements?.length == 0)
          ) {
            this.is_can_edit_profile = false;
          }
          // ========== ========== ========== ==========
          const name = this.profileFields.find((x) => x.name == "question1");
          if (!name) {
            this.profileFields.push({
              name: "question1",
              title: "ชื่อ",
            });
          }
          const surname = this.profileFields.find((x) => x.name == "question2");
          if (!surname) {
            this.profileFields.push({
              name: "question2",
              title: "นามสกุล",
            });
          }
          const phone = this.profileFields.find((x) => x.name == "question3");
          if (!phone) {
            this.profileFields.push({
              name: "question3",
              title: "เบอร์โทร",
            });
          }
        })
        .catch((error) => {
          console.error("Error loading profile:", error);
          this.$swal.fire({
            icon: "error",
            title: JSON.stringify(error.response.data.message),
            showConfirmButton: true,
          });
        })
        .finally(() => {
          this.isAppLoading(false);
        });
    },
    saveLogoImage(imageFile) {
      let formData = new FormData();
      formData.append("image", imageFile);

      this.isAppLoading(true);

      Axios.post("uploadImageProfile", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((res) => {
          if (res.data.status === "success") {
            this.$swal.fire({
              icon: "success",
              title: this.$t("uploadSuccessful"),
              showConfirmButton: false,
              timer: 2000,
            });
            this.initialize();
          } else {
            this.$swal.fire(this.$t("error.title"), res.data.error, "error");
          }
        })
        .catch(() => {
          this.$swal.fire({
            icon: "error",
            text: this.$t("errSubmissionFailed"),
            showConfirmButton: false,
            timer: 2000,
          });
        })
        .finally(() => {
          this.isAppLoading(false);
        });
    },
    triggerFileInput() {
      if (!this.is_can_edit_image_profile) return;
      this.$refs.fileInput.click();
    },
    onFileUpload(event) {
      const file = event.target.files[0];
      if (!file) {
        return;
      }
      this.url = URL.createObjectURL(file);
      this.saveLogoImage(file);
      event.target.value = null;
    },
    cancelEdit() {
      this.isEditing = false;
      this.pendingSurveyData = null;
      if (this.survey && this.dataItems.detail) {
        this.survey.data = { ...this.dataItems.detail };
      }
    },
    isImage(link) {
      return /\.(gif|jpe?g|jfif|tiff?|png|webp|bmp|avif|svg)$/i.test(link);
    },
    isVideo(link) {
      return /\.(mp4|webm|ogg|avi|mov)$/i.test(link);
    },
    isPDF(link) {
      return /\.pdf$/i.test(link);
    },
    isSpreadsheet(link) {
      return /\.(xls|xlsx|csv)$/i.test(link);
    },
    isHeic(link, mimeType = "") {
      const isExtensionHeic = /\.(heic|heif)$/i.test(link);
      const isMimeHeic = ["image/heic", "image/heif"].includes(
        mimeType.toLowerCase()
      );
      return isExtensionHeic || isMimeHeic;
    },
    async convertBase64ToFile(base64, filename) {
      const res = await fetch(base64);
      const blob = await res.blob();
      return new File([blob], filename, { type: blob.type });
    },
    async uploadImageDefault(imageFile) {
      let formData = new FormData();
      formData.append("image", imageFile);

      try {
        const res = await Axios.post("uploadImage", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        if (res.data.status === "success") {
          return res.data.url;
        }
        return null;
      } catch (error) {
        console.error("Error uploading image:", error);
        return null;
      }
    },
  },
};
</script>

<style scoped>
::v-deep .v-btn__content {
  display: flex;
  flex-direction: row;
}
.card-profile-container {
  margin-top: -50px !important;
  position: relative !important;
}
.cancel-edit-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 10;
}
</style>